(function($) {

    function playPauseVideo() {
        let videos = document.querySelectorAll(".wp-block-media-text.slick-slide video");
        videos.forEach((video) => {
            // We can only control playback without insteraction if video is mute
            video.muted = true;
            video.control = false;
            // Play is a promise so we need to check we have it
            let playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.then((_) => {
                    let observer = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                if (
                                    entry.intersectionRatio !== 1 &&
                                    !video.paused
                                ) {
                                    video.pause();
                                } else if (video.paused) {
                                    video.play();
                                }
                            });
                        },
                        { threshold: 0.2 }
                    );
                    observer.observe(video);
                });
            }
        });
    }

    // And you would kick this off where appropriate with:
    playPauseVideo();


    var vids = $(".wp-block-media-text.slick-slide video"); 
    $.each(vids, function(){
           this.controls = false; 
    }); 
    //Loop though all Video tags and set Controls as false

    $(".wp-block-media-text.slick-slide video").click(function() {
      //console.log(this); 
      if (this.paused) {
        this.play();
      } else {
        this.pause();
      }
    });

})(jQuery);